/**
 * DeclineQuoteModal - Modal for declining a quote with a required reason
 */

import { useState } from 'react';
import { OathModal, OathButton, OathAlert } from '../../../shared/OathUI';

const DeclineQuoteModal = ({ isOpen, onClose, onConfirm, isSubmitting }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Please provide a reason for declining the quote.');
      return;
    }
    setError('');
    onConfirm(reason.trim());
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  return (
    <OathModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Decline Quote"
      size="md"
      footer={
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto sm:ml-auto">
          <OathButton
            variant="outline"
            onClick={handleClose}
            disabled={isSubmitting}
            className="w-full sm:w-auto"
          >
            Cancel
          </OathButton>
          <OathButton
            variant="danger"
            onClick={handleConfirm}
            loading={isSubmitting}
            className="w-full sm:w-auto"
          >
            {isSubmitting ? 'Declining...' : 'Decline Quote'}
          </OathButton>
        </div>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Please provide a reason for declining this quote.
        </p>
        {error && <OathAlert variant="error" message={error} />}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Reason <span className="text-red-500">*</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Reason for declining"
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-xl text-sm text-gray-900 dark:text-white bg-white dark:bg-gray-700 focus:ring-2 focus:ring-primary/20 focus:border-primary resize-none"
            rows={4}
          />
        </div>
      </div>
    </OathModal>
  );
};

export default DeclineQuoteModal;
